export enum TabId {
  MAIN_TAB = 'main-tab',
  DESIGN_TAB = 'design-tab',
  DISPLAY_TAB = 'display-tab',
  LAYOUT_TAB = 'layout-tab',
  ADDONS_TAB = 'add-ons-tab',
  SUPPORT_TAB = 'support-tab',
}
